export const FALLBACK_FILTERS = [
  {
    options: ['All', 'Anxiety', 'Stress', 'Confidence', 'PTSD', 'Trauma', 'Depression'],
    label: 'Focus Area',
    key: 'focusArea',
  },
  {
    options: ['All', 'CBH', 'Parts', 'Regression'],
    label: 'Modality',
    key: 'modality',
  },
  {
    options: ['All', 'Weekdays', 'Evenings', 'Weekends'],
    label: 'Availability',
    key: 'availability',
  },
  {
    options: ['All', 'English', 'Spanish', 'Urdu', 'French', 'Arabic'],
    label: 'Language',
    key: 'language',
  },
  {
    options: ['All', 'Female', 'Male', 'Non-binary'],
    label: 'Gender',
    key: 'gender',
  },
];

export const COLORS = {
  SUBTEXT: 'rgba(41,30,23,0.72)',
  STROKE: '#D9CEC7',
};
